//#region Icons
import PersonIcon from "icons/PersonIcon";
import AtIcon from "icons/AtIcon";
import OpenEyeIcon from "icons/OpenEyeIcon";
import BriefcaseIcon from "icons/BriefcaseIcon";
import CalendarIcon from "icons/CalendarIcon";
import SmileIcon from "icons/SmileIcon";
//#endregion

export const INIT_FILTER_FIELDS = {
    nameSurnameOrUser: "",
    categoryId: 0,
    roleId: 0,
    creationDate: -1
};
export const HEADERS_TABLE_LIST = [
    {
        title: "Usuario", 
        icon: <AtIcon/>
    },
    {
        title: "Nombres", 
        icon: <PersonIcon/>
    },
    {
        title: "Apellidos", 
        icon: <SmileIcon/>
    },
    {
        title: "Categoría", 
        icon: <OpenEyeIcon/>
    },
    {
        title: "Rol", 
        icon: <BriefcaseIcon/>
    },
    {
        title: "Creación", 
        icon: <CalendarIcon/>
    },
    {
        title: "Editar"
    },
    {
        title: "Eliminar"
    }
];
export const SAMPLE_DATA = [
    {
        fullName: "Manuel Rivera",
        user: "manuelrb",
        category: {
            id: 1,
            name: "Eventos"
        },
        role: {
            id: 1,
            name: "Admin"
        },
        creationDate: "04/09/2022"
    },
    {
        fullName: "Sol Quevedo",
        user: "sol.quev",
        category: {
            id: 2,
            name: "Refuerzos"
        },
        role: {
            id: 3,
            name: "Tutor"
        },
        creationDate: "04/09/2022"
    }
];
export const RECORDS_BY_PAGE = 10;